import { ChoiceList } from "./ChoiceList";
import { NumberInput, TextInput } from "./NumberInput";
import { BigButton, UrgentNotice } from "./PublicShell";

function SectionProgress({ sections, current }) {
  const idx = sections.findIndex((s) => s.code === current);
  return (
    <div data-testid="checkin-section-progress">
      <p className="text-sm font-semibold text-zinc-600">
        Section {idx + 1} of {sections.length} · <span className="text-zinc-900">{sections[idx]?.label}</span>
      </p>
      <div className="mt-2 flex gap-1.5" aria-hidden="true">
        {sections.map((s, i) => (
          <span key={s.code} className={`h-2 flex-1 rounded-full ${i < idx ? "bg-zinc-700" : i === idx ? "bg-zinc-900" : "bg-zinc-300"}`} />
        ))}
      </div>
    </div>
  );
}

function Input({ q, value, onChange, labelId }) {
  if (["single", "multi", "yes_no_unsure"].includes(q.type)) return <ChoiceList q={q} value={value} onChange={onChange} labelId={labelId} />;
  if (["short_text", "long_text"].includes(q.type)) return <TextInput q={q} value={value} onChange={onChange} labelId={labelId} />;
  return <NumberInput q={q} value={value} onChange={onChange} labelId={labelId} />;
}

export function QuestionStep({ template, q, value, onChange, error, confirmHigh, onBack, onNext, nextLabel }) {
  const labelId = `checkin-q-${q.code}`;
  const urgentVals = template.urgent_triggers?.[q.code] || [];
  const urgent = (Array.isArray(value) ? value : [value]).some((v) => urgentVals.includes(v));
  return (
    <div className="space-y-6" data-testid={`checkin-question-${q.code}`}>
      <SectionProgress sections={template.sections} current={q.section} />
      <div>
        <h1 id={labelId} tabIndex={-1} className="focus:outline-none font-display text-2xl font-bold leading-snug tracking-tight text-zinc-950 sm:text-3xl">
          {q.prompt}
        </h1>
        {!q.required && <p className="mt-1 text-sm text-zinc-500">Optional</p>}
        {q.help && (
          <details className="mt-3 rounded-lg bg-white/70 px-4 py-3 text-base text-zinc-700" data-testid={`checkin-help-${q.code}`}>
            <summary className="cursor-pointer font-semibold text-zinc-900">What does this mean?</summary>
            <p className="mt-2 leading-relaxed">{q.help}</p>
          </details>
        )}
      </div>
      <Input q={q} value={value} onChange={onChange} labelId={labelId} />
      {urgent && <UrgentNotice text={template.urgent_notice} />}
      {error && <p className="rounded-lg bg-red-50 px-4 py-3 text-base font-semibold text-red-800" role="alert" data-testid="checkin-question-error">{error}</p>}
      {confirmHigh && (
        <p className="rounded-lg border-2 border-amber-400 bg-amber-50 px-4 py-3 text-base text-amber-900" role="alert" data-testid="checkin-confirm-high">
          That&apos;s a lot of exercise — {value} {q.unit}. If that&apos;s right, press Next again.
        </p>
      )}
      <div className="flex gap-3 pt-2">
        <BigButton variant="secondary" onClick={onBack} data-testid="checkin-back-btn">Back</BigButton>
        <BigButton className="flex-1" onClick={onNext} data-testid="checkin-next-btn">{nextLabel}</BigButton>
      </div>
    </div>
  );
}
